import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './formsBrowser.module.scss';
import { SelectionProps } from './types/FormTypes';

export const BackArrow = React.memo(
    (props: { selectionProps: SelectionProps }) => {
        const { t } = useTranslation();

        try {
            const {
                selectionProps: { handleOnBackArrowSelect },
            } = props;

            return (
                <button
                    type="button"
                    className={styles.backArrowContainer}
                    onClick={() => handleOnBackArrowSelect()}
                    aria-label={t('FormsBrowser.BackArrow', 'Go back')}
                >
                    <span className={styles.arrowImg} aria-hidden="true"></span>
                    <span className={styles.arrowText}>
                        {t('FormsBrowser.BackArrow', 'Back')}
                    </span>
                </button>
            );
        } catch {
            return null;
        }
    },
);
